<div class="dialog-content-wrapper">
    <mat-toolbar matDialogTitle class="mat-accent m-0">
        <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
            <span class="title dialog-title">
                {{'Select customer'|translate}}
            </span>
        </mat-toolbar-row>
    </mat-toolbar>

    <div mat-dialog-content class="p-24 pb-0 m-0" fusePerfectScrollbar>
        <form fxLayout="column" fxLayoutAlign="start"
              fxFlex="1 0 auto" name="form" [formGroup]="form">

            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                <mat-form-field appearance="outline" fxFlex="100">
                    <mat-label>{{'Customer'|translate}}</mat-label>
                    <input type="text"
                           placeholder="{{ 'Customer'|translate }}"
                           matInput
                           formControlName="customer"
                           [matAutocomplete]="auto">
                    <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" [displayWith]="displayFn">
                        <mat-option [value]="customer" *ngFor="let customer of filteredOptions|async">
                            {{customer.firstName}} {{customer.lastName}}; {{customer.phone}}
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>
            </div>


            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                <mat-checkbox formControlName="invoice" fxFlex="100" (change)="wantInvoice($event)">
                    <mat-label>{{'Create invoice'|translate}}</mat-label>
                </mat-checkbox>
            </div>

            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto" *ngIf="form.controls['invoice'].value">

                <mat-form-field appearance="outline" fxFlex="50" class="pr-4">
                    <mat-label>{{'NIP'|translate}}</mat-label>
                    <input
                            matInput
                            formControlName="nip"
                            [ngClass]="{ 'is-invalid': f['nip']?.touched && f['nip'].errors }"
                    >
                    <mat-hint>
                        {{'VAT ID is required to create invoice'|translate}}
                    </mat-hint>
                </mat-form-field>

                <mat-form-field appearance="outline" fxFlex="50" class="pr-4">
                    <mat-label>{{'Name'|translate}}</mat-label>
                    <input matInput formControlName="companyName">
                </mat-form-field>
            </div>

            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto" *ngIf="form.controls['invoice'].value">

                <mat-form-field appearance="outline" fxFlex="50" class="pr-4">
                    <mat-label>{{'Street'|translate}}</mat-label>
                    <input matInput formControlName="companyStreet">
                </mat-form-field>

                <mat-form-field appearance="outline" fxFlex="20" class="pr-4">
                    <mat-label>{{'Post code'|translate}}</mat-label>
                    <input matInput formControlName="companyPostCode">
                </mat-form-field>

                <mat-form-field appearance="outline" fxFlex="30" class="pl-4">
                    <mat-label>{{'City'|translate}}</mat-label>
                    <input matInput formControlName="companyCity">
                </mat-form-field>
            </div>

            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto" *ngIf="form.controls['invoice'].value">
                <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                    <mat-form-field appearance="outline" fxFlex="40">
                        <mat-label>{{'Country'|translate}}</mat-label>
                        <mat-select formControlName="companyCountry">
                            <mat-option [value]="country.id" *ngFor="let country of countries">
                                {{country.name|translate}}
                            </mat-option>
                        </mat-select>
                        <mat-icon matSuffix class="secondary-text">outlined_flag</mat-icon>
                    </mat-form-field>
                </div>
            </div>

            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                <mat-form-field appearance="outline" fxFlex="100">
                    <mat-label>{{'Worker'|translate}}</mat-label>
                    <mat-select formControlName="worker">
                        <mat-option [value]="worker.id" *ngFor="let worker of workers">
                            {{worker.firstName}} {{worker.lastName}}; {{worker.phone}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

        </form>
    </div>

    <div mat-dialog-actions class="m-0 p-16" fxLayout="row" fxLayoutAlign="end center">

        <button
                mat-button
                class="mr-8"
                (click)="matDialogRef.close()"
                aria-label="Cancel">
            {{'Cancel'|translate}}
        </button>
        <button
                mat-button
                class="mr-8"
                (click)="matDialogRef.close(form)"
                aria-label="Update bill"
                [disabled]="form?.invalid"
        >
            {{'Update bill'|translate}}
        </button>

    </div>
</div>
